export default __webpack_public_path__ + "static/assets/d10a34e19e07d9ba4f11480ece741967.png";